// Questionnaire module

var service = require('./../QuizService');
var spotify = require('./../SpotifyService');
var $ = require('jquery');

module.exports = {
    template: require('./template.html'),
    replace: false,
    data: function () {
        return {
            questions: [
                {
                    'text': 'Why should we hire you?',
                    'answerTracks': [],
                    'searchTracks': [],
                    'search': ''
                },
                {
                    'text': "What's your greatest strength?",
                    'answerTracks': [],
                    'searchTracks': [],
                    'search': ''
                },
                {
                    'text': 'Where do you see yourself in five years?',
                    'answerTracks': [],
                    'searchTracks': [],
                    'search': ''
                },
                {
                    'text': 'What motivates you?',
                    'answerTracks': [],
                    'searchTracks': [],
                    'search': ''

                },
                {
                    'text': 'How do you handle pressure?',
                    'answerTracks': [],
                    'searchTracks': [],
                    'search': ''
                },
                {
                    'text': "What can you offer us that someone else can't?",
                    'answerTracks': [],
                    'searchTracks': [],
                    'search': '',
                    'font': '20px'
                },
                {
                    'text': 'What are your hobbies?',
                    'answerTracks': [],
                    'searchTracks': [],
                    'search': ''
                },
                {
                    'text': 'What are your salary requirements?',
                    'answerTracks': [],
                    'searchTracks': [],
                    'search': '',
                    'lastQuestion': true
                }
            ],
            showStartScreen: false,
            currentQuestion: 0,
            endView: false,
            continueApplication: true,
            questionActive: false,
            showplaylisttracks: false
        }
    },

    computed: {

        questionnaire: function () {
            return this.questions[this.currentQuestion];
        }
    },

    methods: {

        nextQuestion: function () {

            $('.navbarline').css('width', '+=5px');

            var self = this;

            console.log(this.questionnaire);

            if(this.currentQuestion >= 6) {
                $('#nextAnimate').html('FINISH');
            }

            if(this.currentQuestion < 7) {
                this.currentQuestion++;

                if(this.questionnaire.answerTracks > '') {
                    this.questionActive = true;
                    $('#nextAnimate').animate({right:'6%'},300);
                } else {
                    this.questionActive = false;
                    setTimeout(function() {
                        $('#nextAnimate').animate({right:'-250px'},300);
                    },100);
                }

            } else {
                for(var i = 0; i < self.questions.length; i++) {
                    if(self.questions[i].answerTracks == '') {
                        self.continueApplication =  false;
                    } else {
                        self.continueApplication =  true;
                    }
                }
                this.endView = true;

                this.sendResult();

                setTimeout(function() {
                    $('#continueBtnQuestionnaireAnimate').animate({right:'6%'},500);
                },100);
            }
        },

        shareInterView: function () {
            shareInter(service.getId());
        },

        tweetInterview: function () {

            ga('send', 'event', 'Share', 'click', 'Twitter Questionnaire');

            var loc = 'https://thejob.filtr.com';
            var title  = encodeURIComponent('I just completed the ultimate music interview. Do you think you have what it takes? #TheJobByFiltr');
            window.open('http://twitter.com/share?url=' + loc + '&text=' + title + '&', 'twitterwindow', 'height=450, width=550, top='+($(window).height()/2 - 225) +', left='+$(window).width()/2 +', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');

        },

        questionShareLinkedin: function() {

            interwiewLinkedIn(service.getId());

        },

        prevQuestion: function () {

            $('.navbarline').css('width', '-=5px');

            if(this.currentQuestion <= 7 && this.endView == false) {
                this.currentQuestion--;
                $('#nextAnimate').html('NEXT');
            }

            if(this.currentQuestion == 7) {
                this.endView = false;

            }

            if(this.questionnaire.answerTracks > '') {
                this.questionActive = true;
                $('#nextAnimate').animate({right:'6%'},300);

            } else {
                this.questionActive = false;
            }
        },

        doSearch: function (question) {

            if (question.search.length > 2) {
                var query = question.search;
                 this.showplaylisttracks = true;

                spotify.findTracks(query).then(function (response) {
                    question.searchTracks = response.tracks.items;
                });
            } else {
                question.searchTracks = [];
                this.showplaylisttracks = false;
            }
        },
        selectTrack: function (question, track) {

            setTimeout(function() {
                $('#nextAnimate').animate({right:'6%'},300);
            },100);

            this.showplaylisttracks = false;

            question.answerTracks = [track];
            question.searchTracks = [];
            question.search = '';

            this.questionActive = true;

        },
       /* removeTrack: function (question, track) {
            var index = question.answerTracks.indexOf(track);
            question.answerTracks.splice(index, 1);
        }, */

        questionaireStart: function () {
            this.showStartScreen = true;
        },

        questionnaireTheJob: function () {

            ga('send', 'event', 'About', 'click', 'About');

            $('.socialQuiz').toggleClass('active');
            $('.btn').toggleClass('active');
            $('.formwrap').toggleClass('active');
            $('.animateQuiz').toggleClass('active');
            $('.closeopen').toggleClass('active');
            $('.aboutWrapper').toggleClass('active');
            $('.overlay').toggleClass('active');
            $('.startText').toggleClass('active');
            $('.quiztext').toggleClass('active');
            $('.aboutskew').toggleClass('active');
            $('.badgewrapper').toggleClass('active');
            $('.wave').toggleClass('active');
            $('.socialStart').toggleClass('active');
            $('.form').toggleClass('active');
            $('.aboutInnerWrap').toggleClass('active');

        },

        sendResult: function () {

            var self = this;

            var resultArray = new Array();

            for (var i = 0; i < self.questions.length; i++) {
                resultArray.push(self.questions[i].answerTracks[0].name);
            };

            service.sendInterviewData(resultArray);

        }


    },
    ready: function () {

        $('.navbarline').css('width', '87px');

        var self = this;

        // Find tracks for query
        /*var query = "taylor swift";
        spotify.findTracks(query).then(function (response) {
            self.tracks = response.tracks.items;
        });*/
    }
}
